module.exports = __webpack_public_path__ + "img/gc_country_flag_nl.6bc8aff6.svg";